module.exports = __webpack_public_path__ + "static/media/9.649c0ec9.png";